import React from 'react'
import s from './OrderDetails.module.scss'

const Address = ({ address }: { address: any }) => {
    return (
        <div className={s.address}>
            <div className={s.address__title}>
                {address?.user_profiles?.username} (+{address?.user_profiles?.phone})
            </div>
            <div className={s.address__info}>
                <div className={s.address__info_title}>Home</div>
                <div className={s.address__info_address}>{address?.city}, {address?.street} {address?.apartment} </div>
                <div className={s.address__info_number}>+{address?.user_profiles?.phone}</div>
                <div className={s.address__info_number}>{address?.user_profiles?.email}</div>
            </div>
        </div>
    )
}

export default Address